import type {
  AchievementApiResponse,
  GetAchievementsParams,
  CertificateRequestParams,
  CertificateRequestResponse
} from "@ts/interfaces/achievements/api/achievementsApiInterface";
import { get, post } from "./httpClient";

const buildQuery = (params: GetAchievementsParams) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (key === "grade") return;
    if (value === undefined || value === null || value === "") return;
    searchParams.set(key, String(value));
  });

  const query = searchParams.toString();
  return query ? `?${query}` : "";
};

export const getAchievements = async (
  params: GetAchievementsParams
): Promise<AchievementApiResponse> => {
  return await get<AchievementApiResponse>(
    `/user/achievements/${params.grade}${buildQuery(params)}`,
    { suppressGlobalErrors: true }
  );
};

/**
 * Request certificate generation for a specific achievement type.
 * This triggers the backend to generate the certificate if not already done.
 * Returns the certificate status.
 */
export const requestCertificate = async (
  params: CertificateRequestParams
): Promise<CertificateRequestResponse> => {
  const { grade, type, term, course_id: courseId, subject_id: subjectId } = params;
  const payload: Record<string, string | number> = { type };
  if (term !== undefined) payload.term = term;
  // Portal requires snake_case keys — use string literals to satisfy the camelcase lint rule
  if (courseId !== undefined) payload["course_id"] = courseId;
  if (subjectId !== undefined) payload["subject_id"] = subjectId;
  return await post<CertificateRequestResponse>(
    `/user/achievements/${grade}/certificate`,
    payload
  );
};

export const achievementsApi = {
  getAchievements,
  requestCertificate
};
